import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ValuesList from "../Components/ValuesList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./Values.css";

function Values() {
  const [isLoading, setIsLoading] = useState(true);
  const [values, setValues] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedValueId, setSelectedValueId] = useState(null);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/values/organization/${state.organization}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setValues(response.data.values);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.organization]);

  const deleteValue = async (id) => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/values/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/values/organization/${state.organization}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setValues(response.data.values);
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setSelectedValueId(id);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="values-header">
            <h2>{t("Reconocimientos.Valores.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right values-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/values/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Reconocimientos.Valores.NuevoValor")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {values.length === 0 ? (
            <Col className="empty-values center">
              <h5>{t("Reconocimientos.Valores.SinValores")}</h5>
            </Col>
          ) : (
            <ValuesList
              values={values}
              handleShow={handleShow}
              language={state.language}
            />
          )}
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Reconocimientos.Valores.Valor.DeleteValue.Titulo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Reconocimientos.Valores.Valor.DeleteValue.Pregunta")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Reconocimientos.Valores.Valor.DeleteValue.Cancelar")}
            </Button>
            <Button
              variant="danger"
              onClick={() => deleteValue(selectedValueId)}
            >
              {t("Reconocimientos.Valores.Valor.DeleteValue.Eliminar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default Values;
